import { useState } from 'react';
import Accordion from '@mui/material/Accordion';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { selectTaskById } from 'features/tasks/store/tasksSlice';
import {
  selectTasksInOrder,
  selectAllPlanningTasksByProjectId,
} from 'features/tasks/store/tasksSlice';
import AccordionDetails from '@mui/material/AccordionDetails';
import { StyleCounterBadge, StyledAccordionSummary } from 'features/drawers/utils/drawerStyle';
import Button from '@mui/material/Button';
import AccordionActions from '@mui/material/AccordionActions';
import {
  selectDependencyEntities,
  syncDependency,
} from 'features/dependencies/store/dependenciesSlice';
import SelectDependency, {
  handleSyncDependency,
} from 'features/drawers/components/SelectDependency';

/**
 * Dependency Row
 * @param {String} taskId
 * @param {String} ganttId
 * @param {Object} setLoading
 * @returns
 */
const DependencyRow = ({ taskId, ganttId, setLoading, projectId, disableEdit }) => {
  const dispatch = useDispatch();

  const allTasks = useSelector((state) => selectAllPlanningTasksByProjectId(state, projectId));
  const task = useSelector((state) => selectTaskById(state, taskId));
  const dependencyEntities = useSelector((state) => selectDependencyEntities(state));
  const [selectedDependency, setSelectedDependency] = useState([]);

  const handleUpdate = async () => {
    setLoading(true);
    const apiResponse = await dispatch(syncDependency({ selectedDependency, taskId }));
    handleSyncDependency(ganttId, apiResponse.payload);
    setLoading(false);
  };

  const handleCancel = () => {
    setSelectedDependency(task?.dependencies.map((id) => dependencyEntities[id]));
  };

  return (
    <Accordion
      style={{
        boxShadow:
          'rgba(0, 0, 0, 0.2) 1px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 1px 1px 1px 2px',
      }}
    >
      <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Dependency</Typography>
        <StyleCounterBadge count={selectedDependency?.length}>
          {selectedDependency?.length}
        </StyleCounterBadge>
      </StyledAccordionSummary>
      <AccordionDetails>
        <SelectDependency
          allTasks={allTasks}
          dependencyEntities={dependencyEntities}
          disableEdit={disableEdit}
          ganttId={ganttId}
          selectedDependency={selectedDependency}
          setSelectedDependency={setSelectedDependency}
          taskId={taskId}
        />
      </AccordionDetails>
      {!disableEdit && (
        <AccordionActions>
          <Button size="small" onClick={handleCancel}>
            Cancel
          </Button>
          <Button color="primary" size="small" variant="contained" onClick={handleUpdate}>
            Update
          </Button>
        </AccordionActions>
      )}
    </Accordion>
  );
};

export default DependencyRow;
